import { usePageNavigation } from '@shared/components/navigation/usePageNavigation';
import type { BreadcrumbItem } from '@shared/components/navigation/types';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { pendingOrdersEs } from '../../i18n';

export const PendingOrdersBreadcrumb = () => {
  const { i18n } = useTranslation();
  const title = i18n.language === 'es' ? pendingOrdersEs.title : 'Pending Orders';

  const breadcrumbs = useMemo<BreadcrumbItem[]>(() => {
    return [
      {
        label: title,
        title: title,
      },
    ];
  }, [title]);

  usePageNavigation({ breadcrumbs });

  return null;
};
